import React from "react";
import axios from "axios";
import { BASELINE } from "../../util";

// 개별 섹션 카드를 위한 컴포넌트
const SectionCard = ({ name, total, check, onCardClick, setdashboard }) => {
  const progressPercent = total > 0 ? (check / total) * 100 : 0;
  
  return (
    <div 
      onClick={() => { onCardClick(name); setdashboard(1); }}
      className="cursor-pointer bg-gray-100 rounded shadow p-4 hover:bg-gray-200 transition-colors"
    >
      <h2 className="text-lg font-semibold mb-2">{name}</h2>
      <p className="text-sm">Total Problems: {total}</p>
      <p className="text-sm">Checked Problems: {check}</p>
      <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
        <div
          className="bg-blue-600 h-2.5 rounded-full"
          style={{ width: `${progressPercent}%` }}
        ></div>
      </div>
    </div>
  );
};

// 여러 섹션 카드를 한 행에 5개씩 표시하는 컴포넌트
const SectionCards = ({ sections, onCardClick, setdashboard }) => {
  return (
    <div className="grid grid-cols-5 gap-4">
      {sections.map((section, index) => (
        <SectionCard
          key={index}
          name={section.name}
          total={section.total}
          check={section.check}
          onCardClick={onCardClick}
          setdashboard={setdashboard} // setdashboard prop 전달
        />
      ))}
    </div>
  );
};

export default SectionCards;
